import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IReportState } from '../state/IReportState';
import { reportStateReducer } from './reports-reducer';

export interface ReportModuleState {
  reportState: IReportState
};

export const reducers = {
  reportState: reportStateReducer
};

export const getReportModuleState = createFeatureSelector('report');
export const getReportState = createSelector(getReportModuleState, (s: ReportModuleState) => s.reportState);
export const getSsrsConfig = createSelector(getReportState, (s: IReportState) => s.ssrsConfig);
export const getSsrsCategories = createSelector(getReportState, (s: IReportState) => s.ssrsReportCategories);



// WEBPACK FOOTER //
// ./src/app/report/store/reducers/index.ts